import styled from "@emotion/styled";
import { Card, Typography } from "antd";
import { goBack } from "assets/icons/index";
import { useState } from "react";

import BangbowOrder from "./BangbowOrder";
import FinanceSummary from "./FinanceSummary";

type ActiveCard = "pendingPayment" | "inProgress" | "batchSummary" | "completedSummary" | null;

const PointManage = () => {
  const [activeCard, setActiveCard] = useState<ActiveCard>(null);

  return (
    <>
      <Card bordered={false} className="criclebox h-full tabs-mobile">
        <HeaderTabs>
          <IconWrapper>
            <SpanIcon>{goBack}</SpanIcon>
          </IconWrapper>
          <Typography.Title level={5}>รายรับและการถอนเงิน</Typography.Title>
          <RightIconWrapper></RightIconWrapper>
        </HeaderTabs>
        <FinanceSummary activeCard={activeCard} onCardClick={setActiveCard} />
        {activeCard && <BangbowOrder activeTable={activeCard} />}
      </Card>
    </>
  );
};

export default PointManage;

const HeaderTabs = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  flex-direction: row;
`;

const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 30px;
  border-radius: 6px;
  background-color: #ffffff;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    background-color: #efefef;
  }
`;

const SpanIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const RightIconWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;
